import * as React from 'react';
import { SVGProps } from 'react';

const IconWifiSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10.29 5.765A6.039 6.039 0 0 0 6 3.99c-1.68 0-3.2.68-4.29 1.775l-.71-.7A7.035 7.035 0 0 1 6 3a7.035 7.035 0 0 1 5 2.065l-.71.7Z" />
    <path d="M9.227 6.815A4.529 4.529 0 0 0 6 5.475a4.529 4.529 0 0 0-3.227 1.34l.71.7A3.523 3.523 0 0 1 6 6.465c.988 0 1.88.402 2.518 1.05l.709-.7ZM7.454 8.565A2.013 2.013 0 0 0 6 7.95c-.572 0-1.088.236-1.454.615L6 10l1.454-1.435Z" />
  </svg>
);
export default IconWifiSizeXs;
